// extracted by mini-css-extract-plugin
export default {"container":"fvV_KwKViCq2SlQBWLtM","rows":"Mwy3JlR6huDkJDbAcoEr","row":"BkLi5_taf2mybGmCx_eE","color":"xERXnykmRt5QbKSe6Fjl"};